// import React, { useState, useEffect, useContext } from "react";
// import "./contactDetails.css";
// import Box from "@mui/material/Box";
// import Modal from "@mui/material/Modal";
// import Fade from "@mui/material/Fade";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
// import successImg from "../../assets/images/successImg.png";
// import { Formik, useFormik } from "formik";
// import { object, string } from "yup";
// import { axiosInstance } from "../../axiosInstance";
// import { useParams } from "react-router-dom";
// import translations from "./translation.json";
// import { LanguageContext } from "../../Components/LanguageContext";
// import * as Yup from "yup";
// import { toast } from "react-toastify";
// import axios from "axios";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 300,
//   bgcolor: "background.paper", //box color
//   border: "1px solid white", //box border
//   boxShadow: 24,
//   pt: 2,
//   px: 0,
//   pb: 3,
// };
// const ContactSchema = object({
//   contact_number: string().matches(
//     /^\d{10}$/,
//     "Contact Number must be 10 digits"
//   ),

//   // is_accepted:Yup.bool().oneOf([true], "You must accept the terms"),
// });
// export function ContactDetails() {
//   const { language } = useContext(LanguageContext);
//   const [open, setOpen] = React.useState(false);
//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);
//   const [stateId, setStateId] = useState();
//   const [state, setState] = useState([]);
//   const [city, setCity] = useState([]);

//   const params = useParams();
//   const userid = params.id;
//   const formik = useFormik({
//     initialValues: {
//       contact_number: "",
//       // address_l1: "",
//       // address_l2: "",
//       state: "",
//       city: "",
//       address: "",
//       // is_accepted: false,
//     },
//     validationSchema: ContactSchema,
//     onSubmit: async (values) => {
//       try {
//         const contact_number = Number(values.contact_number) || 0;

//         // Merge all data
//         const finalPayload = {
//           ...values,
//           contact_number,
//         };

//         console.log("Submitting payload:", finalPayload);

//         const response = await axiosInstance.patch(
//           `/biodata/${userid}`,
//           finalPayload
//         );
//         if (response.data.status === true) {
//           handleOpen();
//         }
//       } catch (error) {
//         console.error("Submission failed:", error);
//         alert("Something went wrong!");
//       }
//     },
//   });
//   async function LoadUser(id) {
//     try {
//       const response = await axiosInstance.get(`biodata/${id}`);
//       const { data } = response.data;
//       if (data) {
//         const {
//           contact_number = "",
//           state = "",
//           city = "",
//           address = "",
//         } = data;

//         formik.setValues({
//           contact_number,
//           state,
//           city,
//           address,
//         });
//       }
//     } catch (error) {
//       console.error("Error fetching user details", error);
//     }
//   }
//   useEffect(() => {
//     LoadUser(params.id);
//   }, []);

//   async function LoadState() {
//     try {
//       const response = await axios.get(
//         "https://devapi.naticharami.in/api/v1/dropdown/states"
//       );
//       const data = response.data;
//       console.log("State", response.data);
//       setState(data);
//     } catch (error) {
//       console.log("Error white fetching");
//       toast.error("Error white fetching", error);
//     }
//   }
//   useEffect(() => {
//     LoadState();
//   }, []);
//   async function LoadCity(stateId) {
//     try {
//       const response = await axios.get(
//         `https://devapi.naticharami.in/api/v1/dropdown/cities/${stateId}`
//       );
//       const data = response.data;
//       console.log("State", response.data);
//       setCity(data);
//     } catch (error) {
//       console.log("Error white fetching");
//       toast.error("Error white fetching", error);
//     }
//   }
//   useEffect(() => {
//     if (stateId) {
//       LoadCity(stateId);
//     }
//   }, [stateId]);
//   return (
//     <form onSubmit={formik.handleSubmit}>
//       <div>
//         {/* row1 */}
//         <div className="contact-subcontainer">
//           <div>
//             <div className="contact-label">
//               {translations[language].contact_number}
//             </div>
//             <div className="contact-input">
//               <input
//                 type="text"
//                 placeholder="Enter your number"
//                 id="contact_number"
//                 name="contact_number"
//                 onChange={formik.handleChange}
//                 value={formik.values.contact_number}
//               />
//               <div>
//                 {formik.touched.contact_number &&
//                   formik.errors.contact_number && (
//                     <div className="text-danger">
//                       {formik.errors.contact_number}
//                     </div>
//                   )}
//               </div>
//             </div>
//           </div>
//           <div>
//             <div className="contact-label">
//               {translations[language].state}{" "}

//             </div>
//             <div className="contact-input">
//               <select
//                 name="state"
//                 id="state"
//                 value={formik.values.state}
//                 onChange={(e) => {
//                   const selectedId = e.target.value;
//                   formik.setFieldValue("state", selectedId);
//                   setStateId(selectedId);
//                   console.log("Selected State ID:", selectedId);
//                 }}
//                 onBlur={formik.handleBlur}
//                 className={`dropdown-btnBasic ${
//                   formik.touched.state && formik.errors.state ? "error" : ""
//                 }`}
//               >
//                 {state?.map((list) => (
//                   <option value={list.id} key={list.id}>
//                     {list.name}
//                   </option>
//                 ))}
//               </select>
//               <div>
//                 {formik.touched.state && formik.errors.state && (
//                   <div className="text-danger">{formik.errors.state}</div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* row2 */}
//         <div className="contact-subcontainer">
//           <div>
//             <div className="contact-label">
//               {translations[language].city}{" "}

//             </div>

//             <div>
//               <select
//                 name="city"
//                 id="city"
//                 value={formik.values.city}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 className={`dropdown-btnBasic ${
//                   formik.touched.city && formik.errors.city ? "error" : ""
//                 }`}
//               >

//                 {city?.map((list) => (
//                   <option value={list.id} key={list.id}>
//                     {list.name}
//                   </option>
//                 ))}
//               </select>
//               <div className="contact-label" style={{marginTop:'0px'}}>First select the state</div>
//               {formik.touched.city && formik.errors.city && (
//                 <div className="text-danger">{formik.errors.city}</div>
//               )}
//             </div>
//           </div>
//           <div>
//             <div className="contact-label">
//               {translations[language].address}{" "}

//             </div>
//             <div className="contact-input">
//               <input
//                 type="text"
//                 placeholder="Enter address"
//                 id="address_l2"
//                 onChange={formik.handleChange}
//               />
//               {formik.touched.address && formik.errors.address && (
//                 <div className="text-danger">{formik.errors.address}</div>
//               )}
//             </div>
//           </div>
//         </div>
//         {/* row3 */}
//         {/* <div className="contact-subcontainer">
//           <div style={{ marginTop: "20px" }}>
//             <input
//               type="checkbox"
//               name="is_accepted"
//               checked={formik.values.is_accepted}
//               onChange={formik.handleChange}
//             />
//             &nbsp;
//             <span className="checkboxLabel">
//               {translations[language].terms}
//             </span>
//               {formik.errors.is_accepted && formik.touched.is_accepted && (
//               <div className="text-danger">{formik.errors.is_accepted}</div>
//             )}
//           </div>
//         </div> */}
//         {/* modal */}
//         <div>
//           <div className="btnBasicSave">
//             <Button type="submit">{translations[language].btnSubmit}</Button>
//           </div>
//           <Modal
//             aria-labelledby="transition-modal-title"
//             aria-describedby="transition-modal-description"
//             open={open}
//             onClose={handleClose} //close modal on background click
//             closeAfterTransition
//           >
//             <Fade in={open}>
//               <Box sx={style} className="modal-box">
//                 <img srcSet={successImg} />
//                 <Typography
//                   id="transition-modal-title"
//                   variant="h6"
//                   component="h2"
//                 >
//                   Thank You
//                 </Typography>
//                 <Typography id="transition-modal-description" sx={{ mt: 2 }}>
//                   The profile has been successfully updated
//                 </Typography>
//               </Box>
//             </Fade>
//           </Modal>
//         </div>
//       </div>
//     </form>
//   );
// }

import React, { useState, useEffect, useContext } from "react";
import "./contactDetails.css";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import successImg from "../../assets/images/successImg.png";
import { useFormik } from "formik";
import { object, string } from "yup";
import { axiosInstance } from "../../axiosInstance";
import { useNavigate, useParams } from "react-router-dom";
import translations from "./translation.json";
import { LanguageContext } from "../../Components/LanguageContext";
import * as Yup from "yup";
import { toast } from "react-toastify";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  border: "1px solid white",
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};

const ContactSchema = object({
  contact_number: string().matches(
    /^\d{10}$/,
    "Contact Number must be 10 digits"
  ),

  //   state: Yup.number().required("State is required"),
  //   city: Yup.number().required("City is required"),
  //   address: Yup.string().required("Address is required"),
});

export function ContactDetails() {
  const { language } = useContext(LanguageContext);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [stateId, setStateId] = useState();
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);

  const navigate = useNavigate();
  const params = useParams();
  const userid = params.id;

  const formik = useFormik({
    initialValues: {
      contact_number: "",
      state: "",
      city: "",
      address: "",
      is_public: false,
      is_web: false,
      is_blur: false,
    },
    validationSchema: ContactSchema,
    onSubmit: async (values) => {
      try {
        const contact_number = Number(values.contact_number) || 0;

        const selectedState = state.find((s) => s.id === Number(values.state));
        const selectedCity = city.find((c) => c.id === Number(values.city));

        const finalPayload = {
          ...values,
          contact_number,
          state: selectedState?.name || "",
          city: selectedCity?.name || "",
        };

        console.log("Submitting payload:", finalPayload);

        const response = await axiosInstance.patch(
          `biodata/${userid}`,
          finalPayload
        );
        if (response.data.status === true) {
          handleOpen();
          setTimeout(() => {
            navigate("/view-more");
          }, 2000);
        }
      } catch (error) {
        console.error("Submission failed:", error);
        alert("Something went wrong!");
      }
    },
  });

  // async function LoadUser(id) {
  //   try {
  //     const response = await axiosInstance.get(`biodata/${id}`);
  //     const { data } = response.data;
  //     const existingData=response.data.data;
  //     console.log("Contact data",existingData);
  //     if (existingData) {
  //       const {
  //         contact_number = "",
  //         // state: stateVal = "",  // <-- coming from backend as ID
  //         // city: cityVal = "",
  //         state = "",
  //         city = "",
  //         address = "",
  //       } = existingData;

  //       formik.setValues({
  //         contact_number,
  //         state,
  //         city,
  //         // state:existingData.state||"",
  //         // city:existingData.city,
  //         // state: Number(stateVal), //Convert to number to match <option value={list.id}>
  //         // city: Number(cityVal),
  //         address,
  //       });

  //       // setStateId(Number(stateVal)); // Trigger city load
  //     }
  //   } catch (error) {
  //     console.error("Error fetching user details", error);
  //   }
  // }
  async function LoadUser(id) {
    try {
      const response = await axiosInstance.get(`biodata/${id}`);
      const existingData = response.data.data;
      console.log("Contact data", existingData);

      if (existingData) {
        const {
          contact_number = "",
          address = "",
          is_public = false,
          is_web = false,
          is_blur = false,
        } = existingData;

        // Find matching state and city by name
        const matchedState = state.find((s) => s.name === existingData.state);
        const matchedCity = city.find((c) => c.name === existingData.city);

        formik.setValues({
          contact_number,
          address,
          state: matchedState?.id || "",
          city: matchedCity?.id || "",
          is_public,
          is_web,
          is_blur,
        });

        // Trigger state change to load cities (if required)
        if (matchedState?.id) setStateId(matchedState.id);
      }
    } catch (error) {
      console.error("Error fetching user details", error);
    }
  }

  useEffect(() => {
    if (state.length > 0) {
      LoadUser(params.id);
    }
  }, [state]);

  // useEffect(() => {
  //   LoadUser(params.id);
  // }, []);

  async function LoadState() {
    try {
      const response = await axios.get(
        "https://devapi.naticharami.in/api/v1/dropdown/states"
        // "https://api.naticharami.in/api/v1/dropdown/states"
      );
      const data = response.data;
      setState(data);
    } catch (error) {
      console.log("Error while fetching states");
      toast.error("Error fetching states");
    }
  }

  useEffect(() => {
    LoadState();
  }, []);

  async function LoadCity(stateId) {
    try {
      const response = await axios.get(
        `https://devapi.naticharami.in/api/v1/dropdown/cities/${stateId}`
        // `https://api.naticharami.in/api/v1/dropdown/cities/${stateId}`
      );
      const data = response.data;
      setCity(data);
    } catch (error) {
      console.log("Error while fetching cities");
      toast.error("Error fetching cities");
    }
  }

  useEffect(() => {
    if (stateId) {
      LoadCity(stateId);
    }
  }, [stateId]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div>
        {/* Row 1 */}
        <div className="contact-subcontainer">
          <div>
            <div className="contact-label">
              {translations[language].contact_number}
            </div>
            <div className="contact-input">
              <input
                type="text"
                placeholder="Enter your number"
                id="contact_number"
                name="contact_number"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.contact_number}
                className={
                  formik.touched.contact_number && formik.errors.contact_number
                    ? "error"
                    : ""
                }
              />
              {formik.touched.contact_number &&
                formik.errors.contact_number && (
                  <div className="text-danger">
                    {formik.errors.contact_number}
                  </div>
                )}
            </div>
          </div>
          <div>
            <div className="contact-label">{translations[language].state}</div>
            <div className="contact-input">
              <select
                name="state"
                id="state"
                value={formik.values.state}
                onChange={(e) => {
                  const selectedId = Number(e.target.value);
                  formik.setFieldValue("state", selectedId);
                  // formik.setFieldValue("city", ""); // reset city
                  setStateId(selectedId);
                }}
                onBlur={formik.handleBlur}
                className={`dropdown-btnBasic ${
                  formik.touched.state && formik.errors.state ? "error" : ""
                }`}
              >
                <option value="" disabled>
                  Select State
                </option>
                {state?.map((list) => (
                  <option value={list.id} key={list.id}>
                    {list.name}
                  </option>
                ))}
              </select>
              {formik.touched.state && formik.errors.state && (
                <div className="text-danger">{formik.errors.state}</div>
              )}
            </div>
          </div>
        </div>

        {/* Row 2 */}
        <div className="contact-subcontainer">
          <div>
            <div className="contact-label">{translations[language].city}</div>
            <div className="contact-input">
              <select
                name="city"
                id="city"
                value={formik.values.city}
                onChange={(e) =>
                  formik.setFieldValue("city", Number(e.target.value))
                }
                onBlur={formik.handleBlur}
                className={`dropdown-btnBasic ${
                  formik.touched.city && formik.errors.city ? "error" : ""
                }`}
              >
                <option value="" disabled>
                  Select City
                </option>
                {city?.map((list) => (
                  <option value={list.id} key={list.id}>
                    {list.name}
                  </option>
                ))}
              </select>
              <div className="contact-label" style={{ marginTop: "0px" }}>
                First select the state
              </div>
              {formik.touched.city && formik.errors.city && (
                <div className="text-danger">{formik.errors.city}</div>
              )}
            </div>
          </div>
          <div>
            <div className="contact-label">
              {translations[language].address}
            </div>
            <div className="contact-input">
              <input
                type="text"
                placeholder="Enter address"
                id="address"
                name="address"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.address}
                className={
                  formik.touched.address && formik.errors.address ? "error" : ""
                }
              />
              {formik.touched.address && formik.errors.address && (
                <div className="text-danger">{formik.errors.address}</div>
              )}
            </div>
          </div>
        </div>

        {/* row3 */}
        <div className="contact-subcontainer mt-3">
          <div>
            <div className="checkboxLabel">
              1. I accept to share my uploaded images publicly for matchmaking
              purposes.
            </div>
            <div
              style={{ marginTop: "10px", marginBottom: "20px" }}
              className="form-check form-switch "
            >
              <input
                type="checkbox"
                id="is_public"
                name="is_public"
                className="form-check-input"
                checked={formik.values.is_public}
                onChange={formik.handleChange}
              />
              &nbsp;
              <span
                style={{
                  color: "#2B171B",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                {formik.values.is_public ? "Yes" : "No"}
              </span>
            </div>
          </div>
        </div>
        {/* row 4 */}
        <div className="contact-subcontainer">
          <div>
            <div className="checkboxLabel">
              {" "}
              2. I accept to share my uploaded images on Nathicharami platform
            </div>
            <div
              style={{ marginTop: "10px", marginBottom: "20px" }}
              className="form-check form-switch "
            >
              <input
                type="checkbox"
                className="form-check-input"
                id="is_web"
                name="is_web"
                checked={formik.values.is_web}
                onChange={formik.handleChange}
              />
              <span
                style={{
                  color: "#2B171B",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                {formik.values.is_web ? "Yes" : "No"}
              </span>
            </div>
          </div>
        </div>
        {/* row 5 */}
        <div className="contact-subcontainer">
          <div>
            <div className="checkboxLabel"> 3. Blur Image in Website</div>
            <div
              style={{ marginTop: "10px", marginBottom: "20px" }}
              className="form-check form-switch "
            >
              <input
                type="checkbox"
                className="form-check-input"
                id="is_blur"
                name="is_blur"
                checked={formik.values.is_blur}
                onChange={formik.handleChange}
              />
              <span
                style={{
                  color: "#2B171B",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                {formik.values.is_blur ? "Yes" : "No"}
              </span>
            </div>
          </div>
        </div>

        {/* Submit Button + Modal */}
        <div>
          <div className="btnBasicSave">
            <Button type="submit">{translations[language].btnSubmit}</Button>
          </div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
          >
            <Fade in={open}>
              <Box sx={style} className="modal-box">
                <img srcSet={successImg} alt="Success" />
                <Typography variant="h6" component="h2">
                  Thank You
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  The profile has been successfully updated
                </Typography>
              </Box>
            </Fade>
          </Modal>
        </div>
      </div>
    </form>
  );
}
